const Skeleton = ({ className }) => (
  <div className={`bg-gray-200 animate-pulse rounded-md ${className}`} />
);

const CardSkeleton = () => (
  <div className="flex items-center rounded-md p-4 bg-white shadow-sm animate-pulse">
    <div className="bg-[#ecf6fe] p-2 rounded-md h-12 w-12 mr-4">
      {/* Icon Placeholder */}
      <Skeleton className="h-full w-full rounded-md" />
    </div>
    <div className="flex flex-col items-center justify-center w-full gap-2">
      {/* Title placeholder */}
      <Skeleton className="h-3 w-2/3" />
      {/* Value placeholder */}
      <Skeleton className="h-6 w-1/2" />
    </div>
  </div>
);

export default CardSkeleton;
